<div class="modal-header" id="escalation-modal-title">
    <h3 class="modal-title" id="modal-title" translate="ESCALATION_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="escalationForm">
        <fieldset>
            <div class="row mb-3">
                <div class="d-flex justify-content-center my-3">
                    <div class="text-center" [innerHTML]="notificationDetails"></div>
                </div>
                <div class="col-12">
                    <span [innerHTML]="escalationMessage"></span>
                </div>
                <div class="col-12 mt-4">
                    <span [innerHTML]="'ESCALATION_TEXT' | translate"></span>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <pace-core-text-input
                        id="textInfo"
                        name="textInfo"
                        [(model)]="model.longTextInfo"
                        [parentForm]="formChildren"
                        [ariaLabel]="'ESCALATION_TEXT' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            &nbsp;
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    @if (!isLoading) {
        <button
            class="btn btn-secondary"
            type="button"
            (click)="modalInstance.hide()"
            translate="SKIP_ESCALATION"
        ></button>
    }
    @if (!isLoading) {
        <button
            class="btn btn-primary"
            type="button"
            [disabled]="escalationForm.invalid"
            (click)="escalateToRSC()"
            translate="ESCALATE"
        ></button>
    }
    @if (isLoading) {
        <progressbar [striped]="true" [value]="100" type="default"> Sending request...</progressbar>
    }
</div>
